import type { BlocksList } from '~/composables/useBlocksList/types';

const blocksList = {
  'item-page': {
    category: 'item-page',
    accessControl: ['product'],
    title: 'Item Page',
    blockName: 'ItemPage',
    variations: [
      {
        title: 'Price Card',
        image: 'https://cdn02.plentymarkets.com/v5vzmmmcb10k/frontend/PWA/Blocks/item_card.svg',
        template: {
          en: {
            name: 'PriceCard',
            type: 'content',
            meta: {
              uuid: 'a1b2c3d4-e5f6-4789-9a0b-1c2d3e4f5a6b',
              isGlobalTemplate: false,
            },
            content: {
              fields: {
                itemName: true,
                price: true,
                tags: true,
                availability: true,
                starRating: true,
                orderProperties: true,
                variationProperties: true,
                previewText: true,
                attributes: true,
                itemBundle: true,
                graduatedPrices: true,
                addToWishlist: true,
                quantityAndAddToCart: true,
                itemText: false,
                technicalData: false,
              },
              fieldsOrder: [
                'itemName',
                'price',
                'tags',
                'availability',
                'starRating',
                'variationProperties',
                'orderProperties',
                'previewText',
                'attributes',
                'itemBundle',
                'graduatedPrices',
                'addToWishlist',
                'quantityAndAddToCart',
                'itemText',
                'technicalData',
              ],
              fieldsDisabled: ['quantityAndAddToCart', 'price', 'itemBundle', 'attributes'],
              wishlistSize: 'small',
              dropShadow: true,
              borders: true,
              borderColor: '#EFF4F1',
              layout: {
                paddingTop: 0,
                paddingBottom: 0,
                paddingRight: 0,
                paddingLeft: 0,
                fullWidth: false,
              },
            },
          },
          de: {
            name: 'PriceCard',
            type: 'content',
            meta: {
              uuid: 'b1c2d3e4-f5a6-4890-0b1c-2d3e4f5a6b7c',
              isGlobalTemplate: false,
            },
            content: {
              fields: {
                itemName: true,
                price: true,
                tags: true,
                availability: true,
                starRating: true,
                orderProperties: true,
                variationProperties: true,
                previewText: true,
                attributes: true,
                itemBundle: true,
                graduatedPrices: true,
                addToWishlist: true,
                quantityAndAddToCart: true,
                itemText: false,
                technicalData: false,
              },
              fieldsOrder: [
                'itemName',
                'price',
                'tags',
                'availability',
                'starRating',
                'variationProperties',
                'orderProperties',
                'previewText',
                'attributes',
                'itemBundle',
                'graduatedPrices',
                'addToWishlist',
                'quantityAndAddToCart',
                'itemText',
                'technicalData',
              ],
              fieldsDisabled: ['quantityAndAddToCart', 'price', 'itemBundle', 'attributes'],
              wishlistSize: 'small',
              dropShadow: true,
              borders: true,
              borderColor: '#EFF4F1',
              layout: {
                paddingTop: 0,
                paddingBottom: 0,
                paddingRight: 0,
                paddingLeft: 0,
                fullWidth: false,
              },
            },
          },
        },
      },
    ],
  },
};

export const getBlocksList = (): BlocksList => blocksList as unknown as BlocksList;
